
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import NavbarLogo from './navigation/NavbarLogo';
import NavbarLinks from './navigation/NavbarLinks';
import NavbarUserMenu from './navigation/NavbarUserMenu';
import NavbarBurgerMenu from './navigation/NavbarBurgerMenu';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4 px-6 md:px-12',
        isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm' : 'bg-transparent'
      )}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <NavbarLogo />

        <nav className="flex items-center gap-6">
          <NavbarLinks />
          <NavbarUserMenu />
          <NavbarBurgerMenu />
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
